import { UrlConstants } from "../url.constants";
export class ApiElectricalConnectionConstants {
    static URL = UrlConstants.API_V2 + "ElectricalConnection";
    static FUNCTION_SET_APPLICANT_AND_APPLICANT_AGENT = "SetElectricalConnectionApplicantAndApplicantAgent";
    static FUNCTION_SET_PROPERTIES = "SetElectricalConnectionProperties";
    static FUNCTION_GET_GENERATE_INVOICE = "GenerateElectricalConnectionInvoiceReport";
    static FUNCTION_CREATE_PARTIAL_APPLICATION = "CreatePartialPortalElectricalConnectionApplication";
    static FUNCTION_GET_GENERATE_REQUIRED_DOCUMENTS_CHECKLIST = "GetElectricalConnectionRequiredDocumentsChecklist";
    static FUNCTION_GET_EXTERNAL_LINKS = "GetExternalLinks";
    static FUNCTION_APPLICATION_TYPES = "GetEcApplicationTypes";
}
